import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  currentPage: number;
  total: number;
  perPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
}

export default function TablePagination({ currentPage, total, perPage, totalItems, onPageChange }: Props): JSX.Element {
  const { t } = useTranslation();
  const totalPages = Math.ceil(total / perPage);
  const from = totalItems === 0 ? 0 : (currentPage - 1) * perPage + 1;
  const to = Math.min(currentPage * perPage, total);

  return (
    <div className="pagination-wrap">
      <span className="pagination-info">
        {t('table.showing')}{' '}
        <strong>
          {from}–{to}
        </strong>{' '}
        {t('table.of')} <strong>{total}</strong>
      </span>

      <div className="pagination-controls">
        <button className="page-btn" disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)}>
          ‹
        </button>

        {Array.from({ length: totalPages }).map((_, index) => {
          const page = index + 1;

          return (
            <button
              key={page}
              className={`page-btn ${page === currentPage ? 'active' : ''}`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          );
        })}

        <button className="page-btn" disabled={currentPage >= totalPages} onClick={() => onPageChange(currentPage + 1)}>
          ›
        </button>
      </div>
    </div>
  );
}
